var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHappy = function SvgHappy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.9704 22.9472C45.9704 10.3304 35.7416 0.101562 23.1248 0.101562C10.508 0.101562 0.280029 10.3304 0.280029 22.9472C0.280029 35.564 10.508 45.7928 23.1248 45.7928C35.7416 45.7928 45.9704 35.564 45.9704 22.9472Z",
    fill: "#EAC03F"
  }), /*#__PURE__*/React.createElement("g", {
    id: "happy-mouth"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 27.9999C8 29.1159 8.1632 30.1919 8.4448 31.2183H27.1056C31.2536 31.2183 33.4584 36.1087 30.7216 39.2255C30.6328 39.3263 30.5432 39.4255 30.4512 39.5231C35.2736 37.9095 38.7536 33.3647 38.7536 27.9999H8Z",
    fill: "#4A141A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5952 40.1575H20.1584C13.444 40.1575 8 34.7143 8 27.9999H38.7536C38.7536 34.7143 33.3096 40.1575 26.5952 40.1575Z",
    fill: "#5F1A1F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.7849 37.2976C32.7849 39.272 28.4617 40.8736 23.1297 40.8736C17.7977 40.8736 13.4745 39.272 13.4745 37.2976C13.4745 35.3224 17.7977 33.7216 23.1297 33.7216C28.4617 33.7216 32.7849 35.3224 32.7849 37.2976Z",
    fill: "#E15D57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1296 33.7216C20.2728 33.7216 17.7144 34.184 15.9464 34.9136C17.2624 34.6648 18.7496 34.5216 20.3296 34.5216C25.6616 34.5216 29.9848 36.1224 29.9848 38.0976C29.9848 39.0144 29.0448 39.848 27.5128 40.4808C30.64 39.8888 32.7848 38.6872 32.7848 37.2976C32.7848 35.3224 28.4616 33.7216 23.1296 33.7216Z",
    fill: "#D1504E"
  })), /*#__PURE__*/React.createElement("g", {
    id: "happy-teeth"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0696 30.8607H14.1896C12.6096 30.8607 11.3296 29.5799 11.3296 27.9999H34.9304C34.9304 29.5799 33.6496 30.8607 32.0696 30.8607Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.6088 27.9999C32.3328 29.2911 31.1872 30.2607 29.8136 30.2607H12.4552C12.9376 30.6311 13.5344 30.8607 14.1896 30.8607H32.0696C33.6496 30.8607 34.9304 29.5799 34.9304 27.9999H32.6088Z",
    fill: "#DEDCD6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1248 0.101562C22.2784 0.101562 21.444 0.151163 20.6216 0.240763C32.0608 1.48796 40.964 11.176 40.964 22.9472C40.964 34.7176 32.0608 44.4064 20.6216 45.6536C21.444 45.7432 22.2784 45.7928 23.1248 45.7928C35.7416 45.7928 45.9704 35.564 45.9704 22.9472C45.9704 10.3304 35.7416 0.101562 23.1248 0.101562Z",
    fill: "#DB9F3B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.96247 22.5407C3.86967 22.5407 3.77927 22.5271 3.69287 22.4983C2.49847 22.1023 2.43447 19.0519 3.55047 15.6855C4.58567 12.5623 6.27287 10.2639 7.46487 10.2639C7.55767 10.2639 7.64727 10.2783 7.73367 10.3063C8.92887 10.7023 8.99207 13.7527 7.87687 17.1191C6.84167 20.2423 5.15447 22.5407 3.96247 22.5407Z",
    fill: "#EBCF5F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "heart-left",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5721 9.55121C13.5529 10.3888 12.5833 12.6872 13.3793 14.7136L13.3769 14.7144L13.4065 14.7856L13.4049 14.7864C12.5329 12.7912 10.2217 11.8536 8.20168 12.6904C6.15848 13.5376 5.18888 15.8816 6.03608 17.9248C6.30648 18.5768 6.72888 19.1184 7.24568 19.5272C9.17928 21.336 12.9049 23.0336 17.5073 24.676L17.4777 24.6048C19.5681 20.1872 20.9993 16.352 21.0865 13.7056C21.1617 13.0504 21.0769 12.3688 20.8065 11.7168C19.9593 9.67361 17.6161 8.70401 15.5721 9.55121Z",
    fill: "#E15D57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8064 11.7168C19.9592 9.67361 17.616 8.70401 15.572 9.55121C15.4568 9.59921 15.3576 9.66721 15.2496 9.72401C16.5456 9.95841 17.7 10.8184 18.2416 12.1248C18.512 12.7768 18.5968 13.4592 18.5216 14.1136C18.4424 16.5344 17.2304 19.956 15.4264 23.9008C16.0992 24.1608 16.788 24.4192 17.5072 24.676L17.4776 24.6048C19.568 20.1872 20.9992 16.352 21.0864 13.7056C21.1616 13.0504 21.0768 12.3688 20.8064 11.7168Z",
    fill: "#D1504E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "heart-right",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.6777 9.55121C32.6969 10.3888 33.6665 12.6872 32.8713 14.7136L32.8729 14.7144L32.8433 14.7856L32.8449 14.7864C33.7169 12.7912 36.0281 11.8536 38.0481 12.6904C40.0913 13.5376 41.0609 15.8816 40.2137 17.9248C39.9433 18.5768 39.5209 19.1184 39.0049 19.5272C37.0705 21.336 33.3449 23.0336 28.7425 24.676L28.7721 24.6048C26.6817 20.1872 25.2505 16.352 25.1633 13.7056C25.0881 13.0504 25.1729 12.3688 25.4433 11.7168C26.2905 9.67361 28.6337 8.70401 30.6777 9.55121Z",
    fill: "#E15D57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.048 12.6904C37.8464 12.6072 37.6416 12.5544 37.436 12.5056C38.1168 13.5712 38.288 14.9392 37.7664 16.196C37.4968 16.848 37.0736 17.3896 36.5576 17.7992C34.8352 19.4096 31.688 20.9312 27.7712 22.4048C28.0864 23.1216 28.4152 23.8512 28.772 24.6048L28.7424 24.676C33.3448 23.0336 37.0704 21.336 39.004 19.5272C39.5208 19.1184 39.9432 18.5768 40.2136 17.9248C41.0608 15.8816 40.0912 13.5376 38.048 12.6904Z",
    fill: "#D1504E"
  }))));
};
export default SvgHappy;